__turbopack_context__.v({
  "art": "page-module__eOuxtW__art",
  "control": "page-module__eOuxtW__control",
  "controls": "page-module__eOuxtW__controls",
  "filmIntro": "page-module__eOuxtW__filmIntro",
  "header": "page-module__eOuxtW__header",
  "home": "page-module__eOuxtW__home",
  "lede": "page-module__eOuxtW__lede",
  "message": "page-module__eOuxtW__message",
  "page": "page-module__eOuxtW__page",
  "playback": "page-module__eOuxtW__playback",
  "stage": "page-module__eOuxtW__stage",
  "title": "page-module__eOuxtW__title",
});
